import { LABEL_URL, DISTRIBUTION_URL } from "../../../services/common-urls";
import { MHTTPCL, JSON_STRING, HttpClient } from "../../../services/http/http-client";
import { HttpLib } from "../../../services/http/http-lib";
// export const DISTRIBUTION_URL = '/distribution.pl';

export const ProductGroupsService = {
  //https://dev.berlin3.com/updatecheck2/label.pl?action=get_product_groups&section=product_groups&row_start=<num>&row_count=<num>&search=<str>
  fetchProductGroupsList:(row_start,row_count,searchString="") =>
    MHTTPCL.get(LABEL_URL, {
      section: "product_groups",
      action: "get_product_groups",
      row_start:row_start,
      row_count:row_count,
      search:searchString

    }),
  addNewProductGroups: product_group_name =>
    MHTTPCL.post(LABEL_URL, {
      section: "product_groups",
      action: "new_product_group",
      product_group_name1: product_group_name
    }),
  fetchProductGroupDetails: product_group_id =>
    MHTTPCL.post(LABEL_URL, {
      section: "product_groups",
      action: "product_group_overview_data",
      product_group_id: product_group_id
    }),
  fetchProductFormatsList: () =>
    MHTTPCL.post(LABEL_URL, {
      section: "product_groups",
      action: "label_and_format_list"
    }),
  fetchProductFilterList: (product_group_id, str, label_id, format_id) =>
    MHTTPCL.post(LABEL_URL, {
      section: "product_groups",
      action: "filter_products",
      product_group_id: product_group_id,
      str: str,
      label_id: label_id,
      format_id: format_id
    }),
  addProducts: (product_group_id, products) =>
    MHTTPCL.post(LABEL_URL, {
      section: "product_groups",
      action: "add_products",
      product_group_id,
      products
    }),
  removeProduct: relation_id =>
    MHTTPCL.post(LABEL_URL, {
      section: "product_groups",
      action: "remove_product",
      relation_id
    }),
  documentTemplateModal: product_group_id =>
    MHTTPCL.get(LABEL_URL, {
      section: "product_groups",
      action: "templates_modal",
      product_group_id
    }),
  fetchProductPriceList: product_group_id =>
    MHTTPCL.get(DISTRIBUTION_URL, {
      section: "reports",
      action: "catalog_report_modal",
      product_group_id,
      output: JSON_STRING
    }),

  getExportProductReportExcel: (product_group_id, price_list_id) =>
    MHTTPCL.postJSONasFormData(
      DISTRIBUTION_URL,
      {
        section: "reports",
        action: "filter_catalog_report",
        label_id: "undefined",
        start_date: "undefined",
        end_date: "undefined",
        format_id: "undefined",
        channel: "undefined",
        category_1: "undefined",
        category_2: "undefined",
        stock_location_id: "undefined",
        price_list_id,
        product_group_id
      },
      {
        responseType: "blob"
      }
    ),

  removeProductGroup: product_group_id =>
    MHTTPCL.post(LABEL_URL, {
      section: "product_groups",
      action: "remove_product_group",
      product_group_id
    }),

  makeRelationFromXls: (formData) => {
      return MHTTPCL.postFormData(LABEL_URL, formData);
    },


  //plugin flag

  productGroupOverviewData:(product_group_id)=>MHTTPCL.post(LABEL_URL,{
    section:'product_groups',
    action:'product_group_overview_data',
    product_group_id:product_group_id,
    output:JSON_STRING
  }),

  pdfInvoiceBatch:(url,data)=>HttpLib.post(url,querystring.stringify({...data},{ arrayFormat: 'brackets' }),{ withCredentials: true })

  

};
